import { PostActionTypeEnum } from "../../types";

export class PostActionModel {
    type!: PostActionTypeEnum | string
}
